import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import SearchBar from "../../../containers/admin/videos-requests/searchbar";
import VideosRequestTable from "../../../containers/admin/videos-requests/table";
import { getAllRequestsRequest } from "../../../modules/admin-modules/video-requests/Actions";
import UserQRCode from "../../../containers/admin/students/models/user-qr-code";
import StudentReport from "../../../containers/admin/students/models/student-report";

const VideosMoreViewRequests = () => {
  const dispatch = useDispatch();
  const model = useSelector((state) => state.model);
  const studentReportModel = useSelector((state) => state.model.isOpen18);
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCount, setFilteredCount] = useState(0);

  useEffect(() => {
    dispatch(getAllRequestsRequest());
  }, []);

  return (
    <Layout>
      <SearchBar 
        setAdd={setAdd} 
        setSelectedData={setSelectedData} 
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        filteredCount={filteredCount}
      />
      <VideosRequestTable 
        setAdd={setAdd} 
        setSelectedData={setSelectedData} 
        searchTerm={searchTerm}
        setFilteredCount={setFilteredCount}
      />
      <UserQRCode
        data={selectedData?.student}
        setSelectedData={setSelectedData}
      />
      {studentReportModel && (
        <StudentReport
          student_id={selectedData?.id}
          selectedData={selectedData}
        />
      )}
    </Layout>
  );
};

export default VideosMoreViewRequests;
